function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechBubble({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.22 509.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      filter: "url(#filter3219)",
      fillRule: "evenodd",
      strokeWidth: 2.1582,
      fill: "#000000",
      fillOpacity: 0.49804
    },
    d: "m329.67 291.75 73.38 49.05-51.44-83.26 100.79 22.92-59.68-51.56h111.4l-103.44-31.5 91.5-39.99-77.05-16.13 39.93-49.35-62.92 9.22 23.12-62.7-59.98 38.897-14.1-57.782-42.63 51.786c0-3.597-25.03-51.051-26.35-51.051-1.33 0-25.8 50.084-25.8 50.084l-44.65-46.266-11.2 54.416-41.83-46.591s-0.91 52.051-3.57 52.051c-2.65 0-63.335-32.271-63.335-32.271s14.562 59.286 14.562 60.716-65.844-10.33-65.844-10.33l54.226 42.76-57.462 19.51s48.166 36.21 46.84 37.64c-1.326 1.44-42.583 37.83-42.583 37.83s73.536-1.79 72.206-1.79c-0.14 1.2-70.309 54.54-70.309 55.97s76.349-19.08 76.349-19.08l-51.444 74.53 85.774-60.44-11.04 66.8 43.45-42.39 16.98 44.05 34.92-39.52 196.01 174.77-154.92-175.47 64.85 26.91-4.71-52.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinejoin: "round",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 10,
      fill: "#f5caf1"
    },
    d: "m307.38 277.18 73.37 49.05-51.44-83.25 100.79 22.91-59.68-51.55h111.4l-103.44-31.5 91.5-39.99-77.05-16.13 39.93-49.35-62.92 9.22 23.13-62.705-59.98 38.896-14.1-57.781-42.64 51.785c0-3.596-25.02-51.051-26.35-51.051-1.32 0-25.79 50.085-25.79 50.085l-44.65-46.255-11.21 54.416-41.83-46.592s-0.91 52.052-3.56 52.052c-2.66 0-63.341-32.271-63.341-32.271s14.561 59.279 14.561 60.709c0 1.44-65.844-10.322-65.844-10.322l54.223 42.764-57.463 19.51c0.0003 0 48.167 36.21 46.84 37.64-1.326 1.43-42.582 37.83-42.582 37.83-0.0004 0 73.534-1.8 72.208-1.8-0.146 1.2-70.312 54.55-70.312 55.98s76.347-19.08 76.347-19.08l-51.441 74.53 85.77-60.45-11.04 66.81 43.46-42.39 16.97 44.05 34.92-39.52 196.01 174.77-154.91-175.47 64.84 26.9-4.7-52.45z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble);
export default __webpack_public_path__ + "static/media/speech-bubble.62536fa2df9eb7606b2841d1c57c785d.svg";
export { ForwardRef as ReactComponent };